import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuditService } from "../services/audit.service";
import { environment } from "../../environments/environment";

@Injectable()
export class AuditHttpErrorInterceptor implements HttpInterceptor {
  constructor(private audit: AuditService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const base = environment.apiBaseUrl.replace(/\/$/, "");
    const urlNoQuery = req.url.split("?")[0] ?? req.url;

    // Only track API calls to our backend (skip assets/3rd party).
    const isApiCall = urlNoQuery.startsWith(base);

    // Avoid recursion: don't audit the audit ingestion call itself.
    const isAuditIngest =
      urlNoQuery === `${base}/auditevents/batch` || urlNoQuery.endsWith("/auditevents/batch");

    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (isApiCall && !isAuditIngest && err instanceof HttpErrorResponse) {
          const safeUrl = urlNoQuery.slice(0, 500);

          this.audit.trackAction(
            "API_ERROR",
            "http_error",
            {
              request: {
                method: req.method,
                url: safeUrl,
              },
              response: {
                status: err.status,
                statusText: err.statusText,
              },
              error: {
                message:
                  (err.error && (err.error.message || err.error.title)) ||
                  (typeof err.error === "string" ? err.error : "") ||
                  err.message ||
                  "HTTP error",
              },
            },
            true
          );
        }

        return throwError(() => err);
      })
    );
  }
}

